@let currentLabel = label();

<div [class.mb-2]="mb()">
  <!-- Label -->
  @if (currentLabel) {
    <label
      [for]="effectiveName + '-button'"
      class="text-[12px] font-bold z-10 break-words transition-all duration-200 ease-in-out"
      [ngClass]="{
        'text-gray-700': !isDisabled() && !isFocused && !isInvalid,
        'text-gray-500': isDisabled(),
        'text-primary-500': !isDisabled() && isFocused && !isInvalid,
        'text-basic': isInvalid && displayError(),
      }"
      [class.bg-white]="outlined()"
      [class.px-1]="outlined()"
    >
      {{ currentLabel }}
    </label>
  }
  <div class="flex items-center gap-2">
    <div class="relative flex-1 min-w-0">
      <button
        type="button"
        [id]="effectiveName + '-button'"
        (click)="toggleDropdown()"
        (focus)="onButtonFocus()"
        (blur)="onButtonBlur()"
        [disabled]="isDisabled()"
        [attr.aria-expanded]="isDropdownOpen"
        [attr.aria-controls]="effectiveName + '-dropdown'"
        [attr.aria-labelledby]="effectiveName + '-label'"
        class="block w-full px-3 py-2 text-left bg-primary_light rounded-xl text-[16px] transition-colors duration-200 pr-10"
        [ngClass]="{
          'bg-transparent border-1': outlined(),
          'border-gray-300': outlined() && !isFocused && !isInvalid,
          'border-gray-400': outlined() && isFocused && !isInvalid,
          'bg-primary_light': !outlined(),
          'border-error': isInvalid && displayError(),
          'text-error': isInvalid && displayError(),
          'bg-gray-200 cursor-not-allowed text-gray-500': isDisabled(),
        }"
      >
        <span class="block truncate min-h-[1.25rem]" [class]="!_value ? 'text-gray-400' : ''">
          @if (hasValue && placeholderDynamic()) {
            {{ dynamicPlaceholderText }}
          } @else if (_value) {
            {{ displayText | translate }}
          } @else {
            {{ placeholder() }}
          }
        </span>
        <span class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <i class="fa-solid fa-caret-down text-md text-basic"></i>
        </span>
      </button>
    </div>
    @if (displayError()) {
      <div class="flex items-center">
        <i
          *ngIf="ngControl?.invalid && ngControl?.touched && !isDisabled()"
          class="fas fa-times-circle text-error text-[20px]"
        ></i>
      </div>
    }
  </div>

  @if (displayError()) {
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  }
</div>

<!-- Template para el dropdown con CDK Overlay -->
<ng-template #dropdownTemplate>
  <div
    class="w-full bg-white shadow-sm max-h-60 rounded-xl text-base overflow-auto focus:outline-none"
  >
    <ul tabindex="-1" role="listbox" [attr.aria-labelledby]="effectiveName + '-label'">
      <!-- Opcional: Opción para volver al placeholder si se desea -->
      @if (placeholder() && _value !== null && !noEmpty()) {
        <li
          (click)="selectPlaceholder()"
          class="cursor-pointer select-none relative py-2 pl-3 pr-9 font-normal hover:bg-primary hover:text-white"
        >
          <span
            class="block truncate"
            [class.font-normal]="_value !== null"
            [class.font-semibold]="_value === null"
            >{{ effectivePlaceholder }}</span
          >
        </li>
      }

      @for (option of options(); track option.value) {
        <li
          (click)="selectOption(option)"
          class="cursor-pointer select-none relative py-2 pl-3 pr-9 font-normal hover:bg-primary hover:text-white"
          [class.bg-primary]="option.value === _value"
          [class.text-white]="option.value === _value"
        >
          <span
            class="block truncate"
            [class.font-semibold]="option.value === _value"
            [class.font-normal]="option.value !== _value"
          >
            {{ option.display | translate }}
          </span>
          @if (option.value === _value) {
            <span class="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          }
        </li>
      }
      @if (options().length === 0 && !placeholder()) {
        <li class="cursor-default select-none relative py-2 px-4">No hay opciones disponibles.</li>
      }
    </ul>
  </div>
</ng-template>
